module.exports = __webpack_public_path__ + "img-dashboard/register/interaction-white.9fd3415d.png";